import { useMediaQuery, useTheme } from '@mui/material';
import type { Breakpoint } from '@mui/material/styles';

export const useBreakpointUp = (breakpoint: Breakpoint | number) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up(breakpoint));
};

export const useBreakpointDown = (breakpoint: Breakpoint | number) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
